import React, { useState } from "react"
import PropTypes from "prop-types"
import dynamic from "next/dynamic"

// Current solution is to use dynamic import, but it's not ideal.
// Read more here: https://github.com/cookpete/react-player/issues/1428

const ReactPlayer = dynamic(() => import("react-player"), { ssr: false })

import {
  Flex,
  Box,
  TextSM,
  IconButton,
  PauseIcon,
  PlayIcon,
  Image,
  AspectRatio,
} from "datastory-shared/ui"

export const AudioPlayer = ({
  audioUrl,
  title,
  imgUrl,
  onProgress,
  ...props
}) => {
  const [playing, setPlaying] = useState(false)
  const [played, setPlayed] = useState(0)

  const handleTogglePlay = () => {
    setPlaying(!playing)
  }

  const handleProgress = e => {
    setPlayed(e.played)
    if (typeof onProgress === "function") onProgress(e)
  }

  const handleCallback = type => e => {
    if (typeof props[type] === "function") props[type](e)
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      p={["sm", null, null, "md"]}
      border="1px solid"
      borderColor={"whiteAlpha.100"}
      boxShadow="md"
      borderRadius="md"
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        visibility="hidden"
        opacity={0}
        pointerEvents="none"
        maxWidth="100%"
      >
        <ReactPlayer
          url={audioUrl}
          playing={playing}
          onProgress={handleProgress}
          onPlay={handleCallback("onPlay")}
          onReady={handleCallback("onReady")}
          onStart={handleCallback("onStart")}
          onDuration={handleCallback("onDuration")}
          onPause={handleCallback("onPause")}
          onBuffer={handleCallback("onBuffer")}
          onSeek={handleCallback("onSeek")}
          onEnded={handleCallback("onEnded")}
          onError={handleCallback("onError")}
          width="100%"
        />
      </Box>

      <Box flex="lg 0 0" pr={["sm", "md"]}>
        <IconButton
          onClick={handleTogglePlay}
          colorScheme="primary"
          icon={playing ? <PauseIcon /> : <PlayIcon />}
        />
      </Box>
      <Box flex="1" pr={["sm", "md"]}>
        <TextSM
          pb="0.5rem"
          mb="0"
          lineHeight={1.25}
          overflow="hidden"
          fontWeight={700}
        >
          {title || "Title"}
        </TextSM>
        <Box
          position="relative"
          width="100%"
          height="0.5rem"
          bg={"blackAlpha.300"}
          borderRadius="pill"
          overflow="hidden"
        >
          <Box
            position="absolute"
            width={played * 100 + "%"}
            bg={"primary.500"}
            height="0.5rem"
          />
        </Box>
      </Box>

      {imgUrl && (
        <Box flex="5rem 0 0" height="5rem" overflow="hidden" borderRadius="50%">
          <Box
            position="relative"
            display="block"
            width="5rem"
            height="5rem"
            top="50%"
            transform="translateY(-50%)"
          >
            <AspectRatio ratio={1}>
              <Image src={imgUrl} alt={""} fill />
            </AspectRatio>
          </Box>
        </Box>
      )}
    </Flex>
  )
}

AudioPlayer.propTypes = {
  audioUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  imgUrl: PropTypes.string,
  onProgress: PropTypes.func,
}
